/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Backbone from 'backbone';
import Radio from 'backbone.radio';

import UserProfileView from '../UserProfileView/UserProfileView';
import OTDSAccessView from '../OTDSAccessView/OTDSAccessView';

import tmplUserDetailsView from './UserDetailsView.hbs';

const UserDetailsView = View.extend({
  template: tmplUserDetailsView,

  ui: {
    profileTab: '#profile',
    otdsAccessTab: '#otds-access'
  },

  regions: {
    profileTab: '@ui.profileTab',
    otdsAccessTab: '@ui.otdsAccessTab'
  },

  events: {
    'save:user': 'onSaveUser'
  },

  onRender() {
    this.showProfile();
    this.showOtdsAccess();

    Radio.channel('selfService').on('save:user', () => this.onSave());
  },

  showProfile() {
    const model = new Backbone.Model({
      roles: this.model.get('roles'),
      profile: this.model.get('profile')
    })
    const userProfile = new UserProfileView({ model })
    this.showChildView('profileTab', userProfile)
  },

  showOtdsAccess() {
    const model = new Backbone.Model({
      profile: this.model.get('profile'),
      groups: this.model.get('groups'),
      edipi: this.model.get('edipi')
    })
    const otdsAccess = new OTDSAccessView({ model })
    this.showChildView('otdsAccessTab', otdsAccess)
  },

  async onSaveUser() {
    await Promise.all([
      this.getChildView('profileTab').onSave(),
      this.getChildView('otdsAccessTab').onSave()
    ]);
  } 
});

export default UserDetailsView;
